<template>
    <div class="d-flex flex-row flex-nowrap gap-3">
        <ColorPicker
            v-model:pureColor="value"
            :disableAlpha="props.disableAlpha"
        />
        <span>{{ normalizeHexColor(value, undefined, props.disableAlpha) }}</span>
    </div>
</template>
<script setup lang="ts">
import { normalizeHexColor } from '@/utilities/colorUtils';
import ColorPicker from '../ColorPicker.vue';

const value = defineModel<string | null>({ required: true });

const props = defineProps<{
    disableAlpha?: boolean;
}>();
</script>
